const QUESTIONS = {
  RUN_PAYROLL: {
    order: 1,
    text: 'Have you run payroll yet this calendar year?',
    answers: {
      yes: 'Yes',
      no: 'No',
    },
    header: 'Tell us a little about your business.',
    prev: null,
    next: {
      default: 'PREV_PAYROLL_PROVIDER',
    },
  },
  PREV_PAYROLL_PROVIDER: {
    order: 2,
    text: 'How do you currently run payroll?',
    answers: {
      new: 'We’re new to running payroll',
      Other: 'We use another online payroll software',
      'We do it ourselves manually': 'We do it ourselves manually',
    },
    header: 'Just a few more questions.',
    prev: 'RUN_PAYROLL',
    next: {
      default: 'WORKERS_TYPE',
    },
  },
  WORKERS_TYPE: {
    order: 3,
    text: 'What type of workers do you need to pay?',
    tooltip:
      'Full or part-time employees get W-2s. Independent contractors get 1099-MISC forms. Which type of worker do you need to pay?',
    answers: {
      'Yes, we have': 'Employees (W-2s)',
      contractor_only: 'Contractors (1099s)',
      'Both W-2 employees and 1099 contractors': 'Both (W-2s & 1099s)',
    },
    other_answer: {
      key: 'I don’t know',
      text: 'I’m not sure yet',
    },
    header: 'Just a few more questions.',
    prev: 'PREV_PAYROLL_PROVIDER',
    next: {
      contractor_only: null,
      default: 'HEALTH_BENEFITS',
    },
  },
  HEALTH_BENEFITS: {
    order: 4,
    text: 'Interested in offering health benefits to your team?',
    answers: {
      yes: 'Yes',
      no: 'No',
    },
    header: 'Just a few more questions.',
    prev: 'WORKERS_TYPE',
    next: {
      default: 'HELPFUL_INFORMATION',
    },
  },
  HELPFUL_INFORMATION: {
    order: 5,
    text: 'What information about Gusto would be most helpful?',
    sub_text: '(Select one or more)',
    answers: {
      features: 'Features',
      pricing: 'Pricing',
      see_demo: 'See a Demo',
      how_to_signup: 'How to Sign Up',
    },
    header: 'One last question.',
    other_answer: {
      key: 'None of the above',
      text: 'None of the above',
    },
    prev: 'HEALTH_BENEFITS',
    next: {
      features: 'PARTICULAR_FEATURES',
      default: null,
    },
    multi_select_answers: true,
  },
  PARTICULAR_FEATURES: {
    order: 5,
    text: 'Which features in particular?',
    sub_text: '(Select one or more)',
    answers: {
      payroll: 'Payroll',
      time_tracking: 'Time Tracking',
      benefits: 'Benefits',
      integrations: 'Integrations',
    },
    header: 'One last question.',
    other_answer: {
      key: 'other',
      text: 'Other',
    },
    prev: 'HELPFUL_INFORMATION',
    next: {
      default: null,
    },
    multi_select_answers: true,
    do_not_count: true,
  },
};

export default QUESTIONS;
